export interface AnalysisHistoryState {
  data: AnalysisHistoryData[] | undefined;
  detail: AnalysisHistoryData | undefined;
  log: AnalysisHistoryLogData[] | undefined;
  count: number | 0;
  searchParams: string;
  arrSpeed: number[] | undefined;
  arrElev: number[] | undefined;
  page: number | 1;
  total: number | 0;
  id: string | undefined;
}

export interface AnalysisHistoryDetailState {
  analysisHistoryDetail: AnalysisHistoryData | undefined;
}

// export interface SearchAnalysisHistory {
//   idntfNum: string;
//   cntrlStDate: string;
//   cntrlEndDate: string;
// }

export interface AnalysisHistoryData {
  cntrlId: string;
  idntfNum: string;
  statusCd: string;
  objectTypeCd: string;
  flghtStDt: string;
  flghtEndDt: string;
  cntrlStDt: Date;
  cntrlEndDt: string;
  ttlTime: number;
  ttlTimeType: string;
  ttlDstnc: number;
  ttlDstncType: string;
  avrgSpeed: number;
  avrgSpeedType: string;
  bttrCnsmptn: number;
  stArea: string;
  endArea: string;
  createDt: string;
  updateDt: string;
}

export interface AnalysisHistoryLogData {
  hstrySno: number;
  cntrlId: string;
  trmnlId: string;

  mssgTypeCd: string;
  statusCd: string;
  lat: number;
  lon: number;
  speed: number;
  speedType: string;
  heading: number;
  elev: number;
  elevType: string;
  mvDstnc: number;
  bttrLvl: number;
  bttrVltg: number;
  trmnlRcvDt: string;
  srvrRcvDt: string;
}

export interface ReponseAnalysisHistoryData {
  data: AnalysisHistoryData[];
  count: number;
}

export const initResponseAnalysisHistoryData = {
  data: undefined,
  detail: undefined,
  log: undefined,
  count: 0,
  searchParams: '',
  arrSpeed: undefined,
  arrElev: undefined,
  page: 1,
  total: 0,
  id: undefined
};
